import React, { useState } from 'react';
import { Shield, MessageCircle, CheckCircle, X, TrendingUp, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import RegistrationModal from './RegistrationModal';
import AttorneyChatButton from './AttorneyChatButton';

const ReadyToSecureCTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('registration');

  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <>
      <RegistrationModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialType={modalType}
      />
    <div className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-900 via-[#1a1a1a] to-black text-white rounded-3xl px-8 py-12 md:px-12 md:py-16">
          {/* Main CTA Content */}
          <div className="text-center mb-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Ready to Unlock These Advantages?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Avoid delays that could put your brand at risk. Begin securing your trademark today and take full advantage of these powerful benefits.
            </p>
          </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <button
            onClick={() => openModal('registration')}
            className="group flex items-center justify-center bg-[#d29b00] hover:bg-[#a87b00] text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#d29b00]/30"
          >
            Start Registration →
          </button>
          
          <AttorneyChatButton variant="outline" />
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-sm">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">Transparent Pricing</span>
          </div>
          <div className="hidden sm:block text-gray-600">•</div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">No Surprise Charges</span>
          </div>
          <div className="hidden sm:block text-gray-600">•</div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-400" />
            <span className="text-gray-300">Fast 24-Hour Response Time</span>
          </div>
        </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ReadyToSecureCTA;
